import { useCallback, useState } from 'react';

interface UseSubscriptionServicePickerProps {
  onAdd: (serviceId: number, count: number) => void;
}

export const useSubscriptionServicePicker = ({
  onAdd,
}: UseSubscriptionServicePickerProps) => {
  const [serviceId, setServiceId] = useState<number | null>(null);
  const [count, setCount] = useState(1);

  const changeCount = useCallback((value: number | null) => {
    setCount(Math.max(value ?? 1, 1));
  }, []);

  const add = useCallback(() => {
    if (serviceId === null) return;

    onAdd(serviceId, count);
  }, [count, onAdd, serviceId]);

  return {
    serviceId,
    count,
    isAddDisabled: serviceId === null,
    changeService: setServiceId,
    changeCount,
    add,
  };
};
